import { defineStore } from 'pinia'
import { ref } from 'vue'

export type NativeStorePlatform = 'ios' | 'android'

/**
 * Blocks the Capacitor shell when the server reports an unsupported app version
 * (per SPEC_force_update_semver.md, CalVer). Web builds do not use this store.
 */
export const useForceUpdateStore = defineStore('forceUpdate', () => {
    const blocked = ref(false)
    const message = ref('')
    const minAppVersionByPlatform = ref<Partial<Record<NativeStorePlatform, string>>>({})
    const upgradeUrls = ref<Partial<Record<NativeStorePlatform, string>>>({})

    function blockFromPolicy(payload: {
        message: string
        minAppVersionByPlatform: Partial<Record<NativeStorePlatform, string>>
        upgradeUrls?: Partial<Record<NativeStorePlatform, string>>
    }): void {
        if (blocked.value) {
            return
        }
        blocked.value = true
        message.value = payload.message
        minAppVersionByPlatform.value = { ...payload.minAppVersionByPlatform }
        upgradeUrls.value = { ...(payload.upgradeUrls ?? {}) }
    }

    return {
        blocked,
        message,
        minAppVersionByPlatform,
        upgradeUrls,
        blockFromPolicy,
    }
})
